import React, { useEffect } from 'react';
import { Grid } from '@mui/material';
import { useDispatch } from 'react-redux';
import { getAssembledReceiptOfExchangeReceipts } from 'src/store/slices/generalMonitoringSlice';
import BuildCircleOutlinedIcon from '@mui/icons-material/BuildCircleOutlined';
import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined';
import { ChartSkeleton, HeroStat, MonitorCard, formatNumber, useCountUp } from 'src/components/monitoring/MonitoringParts';

// Montajı yapılan değişim adedi ve gün bazında ortalama değişim süresi
function AssembledReceiptOfExchangeReceiptsChart() {
  const dispatch = useDispatch();
  const [mainData, setMainData] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  useEffect(() => {
    setLoading(true);
    dispatch(getAssembledReceiptOfExchangeReceipts())
      .then((response) => {
        setMainData(Array.isArray(response.payload) ? response.payload : []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const row = mainData?.[0] || {};
  const count = Number(row.TOPLAMFIS) || 0;
  const avg = Number(row.ORTSURE);
  const countAnim = useCountUp(loading ? 0 : count);
  const avgAnim = useCountUp(loading || isNaN(avg) ? 0 : avg);

  return (
    <MonitorCard title="Montajı Yapılan Değişimler" subtitle="Montaj adedi ve ortalama değişim süresi">
      {loading ? (
        <ChartSkeleton height={130} />
      ) : (
        <Grid container spacing={1.5}>
          <Grid item xs={12} sm={6}>
            <HeroStat icon={<BuildCircleOutlinedIcon />} label="Montajı yapılan değişim" value={formatNumber(Math.round(countAnim))} footer="Montajı tamamlanan değişimler" />
          </Grid>
          <Grid item xs={12} sm={6}>
            <HeroStat
              icon={<TimerOutlinedIcon />}
              label="Ortalama değişim süresi"
              value={isNaN(avg) ? '-' : `${avgAnim.toLocaleString('tr-TR', { maximumFractionDigits: 1 })} gün`}
              footer="Değişim başına ortalama"
            />
          </Grid>
        </Grid>
      )}
    </MonitorCard>
  );
}

export default AssembledReceiptOfExchangeReceiptsChart;
